export const OFFERING_USE_CASE_OPTIONS = [
  { value: 'generic_offering', label: 'Generic offering' },
  { value: 'food_truck_vendor', label: 'Food truck / vendor' },
  { value: 'facebook_seller', label: 'Facebook seller' },
  { value: 'restaurant_business', label: 'Restaurant / business' },
  { value: 'product_seller', label: 'Product seller' },
];

export const OFFERING_SOURCE_OPTIONS = [
  { value: 'manual_concierge', label: 'Manual concierge' },
  { value: 'facebook_dm', label: 'Facebook DM' },
  { value: 'hip_camden', label: 'Hip Camden' },
  { value: 'food_truck', label: 'Food truck' },
  { value: 'marketplace', label: 'Marketplace' },
  { value: 'restaurant_referral', label: 'Restaurant referral' },
  { value: 'business_outreach', label: 'Business outreach' },
  { value: 'phone_call', label: 'Phone call' },
];

export const OFFERING_PRESETS = [
  {
    key: 'food_truck_special',
    name: 'Food truck special',
    summary: 'Single local food special with seller review.',
    source: 'food_truck',
    src: 'food_truck',
    sourceLabel: 'Food truck special',
    useCase: 'food_truck_vendor',
    offeringType: 'product',
    category: 'Food',
    title: 'Local food special',
    description: 'Local food special available nearby.',
    price: '',
    quantityAvailable: 1,
    sellerFacingNotes:
      'Review the item, price, quantity, pickup details, and add a clear photo before publishing.',
  },
  {
    key: 'facebook_item',
    name: 'Facebook item',
    summary: 'Item already posted socially; package it as a rich-share offer.',
    source: 'facebook_dm',
    src: 'hip_camden',
    sourceLabel: 'Facebook seller',
    useCase: 'facebook_seller',
    offeringType: 'product',
    category: 'Local goods',
    title: '',
    description: '',
    price: '',
    quantityAvailable: 1,
    sellerFacingNotes:
      'Review the title, price, quantity, and photo before publishing.',
  },
  {
    key: 'local_service',
    name: 'Local service',
    summary: 'Service provider offer with seller approval.',
    source: 'business_outreach',
    src: 'business_outreach',
    sourceLabel: 'Local service',
    useCase: 'restaurant_business',
    offeringType: 'service',
    category: 'Services',
    title: '',
    description: '',
    price: '',
    quantityAvailable: '',
    sellerFacingNotes:
      'Review the service details, price, and where customers should request help before publishing.',
  },
  {
    key: 'custom_offering',
    name: 'Custom offering',
    summary: 'Start with a blank seller-reviewed offering draft.',
    source: 'manual_concierge',
    src: 'manual_concierge',
    sourceLabel: '',
    useCase: 'generic_offering',
    offeringType: 'product',
    category: '',
    title: '',
    description: '',
    price: '',
    quantityAvailable: 1,
    sellerFacingNotes:
      'Review and adjust this offering before publishing. Add a clear photo for better rich-share performance.',
  },
];

export const OFFERING_SCRIPT_CARDS = [
  {
    tab: 'Facebook',
    title: 'Public Comment - Generic Local Offering',
    text:
      'This looks great. This is exactly the kind of local offering JG LocalOps Camden can help make easier for people to request.\n\nFacebook is great for getting attention. JG LocalOps gives you a clean rich-share link with the offer details and request button in one place, so interest does not get scattered across comments and DMs.\n\nYou stay in control. Adjust anything and only publish it if it looks right.',
    suggestedSources: ['facebook_dm', 'hip_camden', 'manual_concierge'],
    suggestedUseCases: ['facebook_seller', 'generic_offering'],
  },
  {
    tab: 'Facebook',
    title: 'Public Comment - Local Service',
    text:
      'This looks great. This is exactly the kind of local service offering JG LocalOps Camden can help organize into a cleaner request flow.\n\nInstead of interest getting scattered across comments and DMs, people can click one rich-share link, see the details, and request the service from their phone.\n\nYou stay in control. Adjust anything and only publish it if it looks right.',
    suggestedSources: ['business_outreach'],
    suggestedUseCases: ['restaurant_business'],
    suggestedOfferingTypes: ['service'],
  },
  {
    tab: 'Facebook',
    title: 'Public Comment - Service Opening',
    text:
      'This looks great. This is exactly the kind of local service opening JG LocalOps Camden can help organize into a cleaner request flow.\n\nPeople can click one rich-share link, see the details, and request that opening from their phone instead of the interest getting scattered across comments and DMs.\n\nYou stay in control. Adjust anything and only publish it if it looks right.',
    suggestedSources: ['facebook_dm', 'hip_camden'],
    suggestedUseCases: ['facebook_seller', 'restaurant_business'],
    suggestedOfferingTypes: ['service'],
  },
  {
    tab: 'Facebook',
    title: 'Public Comment - Fresh Food / Produce',
    text:
      'This looks great. Fresh local items are exactly the kind of offering JG LocalOps Camden can help make easier to request.\n\nWe can turn today\'s list into a free review link with the details and request button in one place, so people can act from their phone instead of sorting it out in comments and DMs.\n\nYou stay in control. Adjust anything and only publish it if it looks right.',
    suggestedSources: ['food_truck', 'restaurant_referral'],
    suggestedUseCases: ['food_truck_vendor', 'restaurant_business'],
  },
  {
    tab: 'Facebook',
    title: 'Public Comment - Product / Marketplace Item',
    text:
      'This looks like a strong local product offering for JG LocalOps Camden.\n\nFacebook and Marketplace are great for attention. A JG LocalOps rich-share link helps turn that interest into a cleaner request or reservation from someone\'s phone.\n\nYou stay in control. Adjust anything and only publish it if it looks right.',
    suggestedSources: ['marketplace'],
    suggestedUseCases: ['product_seller'],
  },
  {
    tab: 'Facebook',
    title: 'Public Comment - Pickup / Delivery Angle',
    text:
      'This would be a strong JG LocalOps Camden offering.\n\nPeople can request/reserve it from their phone, and if pickup or delivery help is needed, JG LocalOps can help create a separate local pickup request.\n\nYou stay in control. Adjust anything and only publish it if it looks right.',
    suggestedSources: ['food_truck', 'marketplace'],
    suggestedUseCases: ['food_truck_vendor', 'product_seller'],
  },
  {
    tab: 'Facebook',
    title: 'Facebook DM - Generic Seller',
    text:
      'Hey, I saw your post and thought it would be a strong fit for JG LocalOps Camden.\n\nFacebook is great for getting attention, but the interest can get scattered across comments and DMs. JG LocalOps gives you a clean rich-share offering link where people can see the details and request/reserve from their phone.\n\nI can create a draft and send you a free review link. You can edit anything before it goes live, and nothing publishes unless you approve it.\n\nOnce published, you can post the rich link back on Facebook, send it by text, or share it anywhere else.\n\nWhat is the best email to send the review link to?',
    suggestedSources: ['facebook_dm', 'hip_camden'],
    suggestedUseCases: ['facebook_seller'],
  },
  {
    tab: 'Facebook',
    title: 'Facebook DM - Service Opening',
    text:
      'Hey, I saw your post about the opening. This is a strong fit for JG LocalOps Camden because people are not just looking at a service, they are trying to grab a specific time slot.\n\nJG LocalOps can turn that into a local offering people can request from their phone. You still review everything first, and nothing publishes unless you approve it.\n\nI can create a draft with the photos, service details, pricing notes, and request button together.\n\nWhat is the best email to send the free review link to?',
    suggestedSources: ['facebook_dm', 'hip_camden'],
    suggestedUseCases: ['facebook_seller', 'restaurant_business'],
    suggestedOfferingTypes: ['service'],
  },
  {
    tab: 'Facebook',
    title: 'Facebook DM - Fresh Food / Produce',
    text:
      'Hey, I saw the fresh food post. This is a strong fit for JG LocalOps Camden because your inventory changes and people need a simple way to request what is available.\n\nFacebook is great for getting attention, but orders and questions can get scattered across comments and DMs. A JG LocalOps offering gives people the details and request/reserve button in one place, plus a rich-share link you can post back on Facebook or send by text.\n\nI can create a draft and send you a free review link. You can edit the list, prices/details, pickup notes, photos, and anything else before it goes live.\n\nWhat is the best email to send the review link to?',
    suggestedSources: ['food_truck', 'restaurant_referral'],
    suggestedUseCases: ['food_truck_vendor', 'restaurant_business'],
  },
  {
    tab: 'Facebook',
    title: 'Facebook DM - Beauty / Salon',
    text:
      'Hey, I saw your service post and thought it would be a great fit for JG LocalOps Camden.\n\nYour post already has what a good local offer needs: a clear service, a visual example, and a reason for someone to request it. JG LocalOps can add the missing piece: a request button and rich-share link people can use from their phone.\n\nI can create a draft offering and send you a free review link. You can edit everything before it goes live, and nothing publishes unless you approve it.\n\nWhat is the best email to send the review link to?',
    suggestedSources: ['facebook_dm', 'hip_camden', 'business_outreach'],
    suggestedUseCases: ['facebook_seller', 'restaurant_business'],
    suggestedOfferingTypes: ['service'],
  },
  {
    tab: 'Facebook',
    title: 'Facebook DM - Vehicle / Cleaning',
    text:
      'Hey, I saw your post and thought it would fit JG LocalOps Camden really well.\n\nYou already have strong photos and a clear local service. JG LocalOps can turn that into a requestable offering with the photos, service details, pricing notes, and request button together.\n\nI can send you a free review link first. You can edit anything before it goes live, and nothing publishes unless you approve it.\n\nWhat is the best email to send the review link to?',
    suggestedSources: ['facebook_dm', 'business_outreach'],
    suggestedUseCases: ['facebook_seller', 'restaurant_business'],
    suggestedOfferingTypes: ['service'],
  },
  {
    tab: 'Marketplace',
    title: 'Marketplace DM',
    text:
      'Hey, I saw this on Marketplace and thought it could also work well as a JG LocalOps Camden offering.\n\nMarketplace is great for attention. JG LocalOps can give you a rich-share link with the details and request/reserve button in one place, so local interest is easier to organize.\n\nI can create a draft and send you a free review link. You can edit anything before it goes live, and nothing publishes unless you approve it.\n\nWhat is the best email to send the review link to?',
    suggestedSources: ['marketplace'],
    suggestedUseCases: ['facebook_seller', 'product_seller'],
  },
  {
    tab: 'Food Truck',
    title: 'Food Truck / Vendor',
    text:
      'We can help you create a free JG LocalOps Camden offering for one lunch special.\n\nThe value is not just another post. It gives people a rich-share link with the photo, price, details, and request button together so they can act on it from their phone.\n\nYou can share it on Facebook, Hip Camden, Marketplace, or by text. I can send you a review link first, and you only publish it if it looks right.',
    suggestedSources: ['food_truck'],
    suggestedUseCases: ['food_truck_vendor'],
  },
  {
    tab: 'Pickup',
    title: 'Product / Food Pickup-Delivery Explanation',
    text:
      'If someone wants the item but needs pickup or delivery help, JG LocalOps can also help create a separate local pickup request.\n\nSo the offering helps people request what you have, and the pickup side can help move it locally when needed.',
    suggestedSources: ['food_truck', 'marketplace'],
    suggestedUseCases: ['food_truck_vendor', 'product_seller'],
  },
  {
    tab: 'Business',
    title: 'Restaurant / Business',
    text:
      'If you have a special, featured item, or service you want people to know about, JG LocalOps Camden can help package it as a local offering.\n\nYou get a free review link first, so you can approve the wording, price, photo, and details before it goes live.\n\nOnce published, you get a rich-share link you can post anywhere.',
    suggestedSources: ['restaurant_referral', 'business_outreach'],
    suggestedUseCases: ['restaurant_business'],
  },
  {
    tab: 'Product',
    title: 'Local Product Seller',
    text:
      'This looks like a strong local product offering.\n\nJG LocalOps Camden can give it a cleaner local page with the item, price, photo, and request button together.\n\nYou review everything before publishing, and once it is live you can share the rich link on Facebook, Marketplace, or by text.',
    suggestedSources: ['marketplace', 'facebook_dm', 'hip_camden'],
    suggestedUseCases: ['product_seller', 'facebook_seller'],
  },
  {
    tab: 'Service',
    title: 'Local Service Provider',
    text:
      'JG LocalOps Camden can help package your service as a local offering so people nearby can request it from their phone.\n\nYou can review the title, description, pricing notes, photos, and details before publishing.\n\nIf it looks right, you publish it and get a rich-share link to share locally.',
    suggestedSources: ['business_outreach', 'phone_call'],
    suggestedUseCases: ['restaurant_business'],
    suggestedOfferingTypes: ['service'],
  },
  {
    tab: 'Close',
    title: 'Email Close',
    text:
      'Great. What is the best email to send the review link to?\n\nYou can review everything first, adjust anything, and only publish it if it looks right.',
    suggestedSources: ['manual_concierge', 'phone_call'],
    suggestedUseCases: ['generic_offering'],
  },
  {
    tab: 'Close',
    title: 'Busy Seller',
    text:
      'No problem. I can send you a free review link so you can look at it later.\n\nYou can adjust anything and only publish it if it looks right. What is the best email?',
    suggestedSources: ['phone_call', 'business_outreach', 'restaurant_referral'],
  },
  {
    tab: 'Follow-up',
    title: 'After Review Link Sent',
    text:
      'I just sent the review link. Open it, review the offering, adjust anything you want, and publish it only if it looks right.\n\nAfter it publishes, the best next step is to share the rich link back on Facebook or by text so local people can request it from their phone.',
  },
  {
    tab: 'Media',
    title: 'No Photo / Media Nudge',
    text:
      'Before publishing, add a clear photo if you can. Rich-share links perform much better when people can see the item or service clearly.',
  },
  {
    tab: 'Follow-up',
    title: 'After Publish - Share Nudge',
    text:
      'Your offering is live. The next best step is to share the rich link.\n\nPost it on Facebook, Hip Camden, Marketplace, or send it by text so local people can request it from their phone.',
  },
  {
    tab: 'Objection',
    title: 'Cost Question',
    text:
      'Creating the offering is free right now. The goal is to help local vendors and sellers test whether people respond to a requestable rich-share offering.',
  },
  {
    tab: 'Facebook',
    title: 'Already Posts on Facebook',
    text:
      'That is perfect. JG LocalOps Camden does not replace your Facebook post. It gives that attention a cleaner next step.\n\nInstead of interest getting scattered across comments and DMs, people can click, see the details, and request or reserve from their phone.',
    suggestedSources: ['facebook_dm', 'hip_camden'],
    suggestedUseCases: ['facebook_seller'],
  },
  {
    tab: 'Objection',
    title: 'DoorDash Comparison',
    text:
      'Not exactly. This is more local and broader. It can be food offerings, local products, services, errands, pickups, delivery help, yard help, and small jobs.\n\nThe idea is Camden people helping Camden people.',
  },
  {
    tab: 'Objection',
    title: 'Skeptical Seller',
    text:
      'No pressure. The easiest way to test it is one item, one link, one post.\n\nIf people respond, great. If not, you have not changed how you already sell.',
  },
];

export const isOfferingScriptSuggested = (card, form = {}) => {
  const source = form.source || '';
  const useCase = form.useCase || '';
  const offeringType = form.offeringType || '';
  return Boolean(
    (Array.isArray(card.suggestedSources) &&
      card.suggestedSources.includes(source)) ||
      (Array.isArray(card.suggestedUseCases) &&
        card.suggestedUseCases.includes(useCase)) ||
      (Array.isArray(card.suggestedOfferingTypes) &&
        card.suggestedOfferingTypes.includes(offeringType)),
  );
};

export const trimOfferingValue = (value) => String(value || '').trim();

export const getOfferingPreset = (presetKey) =>
  OFFERING_PRESETS.find((preset) => preset.key === presetKey) ||
  OFFERING_PRESETS.find((preset) => preset.key === 'custom_offering');

export const buildDefaultOfferingConciergeForm = () => ({
  presetKey: 'custom_offering',
  sellerEmail: '',
  sellerName: '',
  sellerPhone: '',
  source: 'manual_concierge',
  src: 'manual_concierge',
  sourceLabel: '',
  useCase: 'generic_offering',
  offeringType: 'product',
  category: '',
  title: '',
  description: '',
  price: '',
  quantityAvailable: '1',
  pickupAddress: '',
  sellerFacingNotes:
    'Review and adjust this offering before publishing. Add a clear photo for better rich-share performance.',
  internalNotes: '',
  originalRequest: '',
});

export const applyOfferingPresetToForm = (form, presetKey) => {
  const preset = getOfferingPreset(presetKey);
  return {
    ...form,
    presetKey: preset.key,
    source: preset.source,
    src: preset.src || preset.source,
    sourceLabel: preset.sourceLabel,
    useCase: preset.useCase,
    offeringType: preset.offeringType,
    category: preset.category,
    title: preset.title,
    description: preset.description,
    price: preset.price,
    quantityAvailable: preset.quantityAvailable === '' ? '' : String(preset.quantityAvailable),
    sellerFacingNotes: preset.sellerFacingNotes,
  };
};

export const buildOfferingDraftPayload = (form) => ({
  sellerEmail: form.sellerEmail,
  sellerName: form.sellerName,
  sellerPhone: form.sellerPhone,
  source: form.source,
  src: form.src,
  sourceLabel: form.sourceLabel,
  useCase: form.useCase,
  offeringType: form.offeringType,
  category: form.category,
  title: form.title,
  description: form.description,
  price: Number(form.price),
  quantityAvailable:
    form.offeringType === 'service' && !trimOfferingValue(form.quantityAvailable)
      ? undefined
      : Number(form.quantityAvailable),
  pickupAddress: form.pickupAddress,
  sellerFacingNotes: form.sellerFacingNotes,
  internalNotes: form.internalNotes,
  originalRequest: form.originalRequest,
  regionSlug: 'camden',
  marketSlug: 'camden',
  intent: 'post_offering',
});
